module.exports = __webpack_public_path__ + "static/media/configuration.5cf03ab3.svg";